(() => {
  const root = document.querySelector('[data-treedix-product-experience]');
  if (!root) return;

  const stickyBuy = root.querySelector('[data-sticky-buy-bar], [data-pxp-sticky-buy]');
  if (stickyBuy && stickyBuy.parentElement !== document.body) {
    document.body.appendChild(stickyBuy);
  }

  const all = (selector) => {
    const nodes = Array.from(root.querySelectorAll(selector));
    if (stickyBuy) nodes.push(...Array.from(stickyBuy.querySelectorAll(selector)));
    return nodes;
  };

  const mainImageContainer = root.querySelector('[data-pxp-main-image-container]');
  const zoomLink = root.querySelector('[data-pxp-zoom]');

  const setupHoverZoom = () => {
    if (!mainImageContainer) return;

    const mediaQuery = window.matchMedia('(min-width: 981px)');
    const zoomPane = document.createElement('div');
    zoomPane.className = 'tl-pfinal-hover-zoom';
    zoomPane.setAttribute('aria-hidden', 'true');
    document.body.appendChild(zoomPane);

    const lens = document.createElement('div');
    lens.className = 'tl-pfinal-hover-lens';
    lens.setAttribute('aria-hidden', 'true');
    mainImageContainer.appendChild(lens);

    let isActive = false;

    const currentImage = () => mainImageContainer.querySelector('img');
    const zoomSource = () => zoomLink?.href || currentImage()?.currentSrc || currentImage()?.src || '';
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const hideZoom = () => {
      isActive = false;
      zoomPane.classList.remove('is-visible');
      lens.classList.remove('is-visible');
    };

    const placeZoomPane = (rect) => {
      const pageGap = 16;
      const panelGap = 16;
      let width = Math.min(520, Math.max(360, window.innerWidth - rect.right - panelGap - pageGap));
      let height = Math.min(560, Math.max(360, rect.height), window.innerHeight - pageGap * 2);
      let left = rect.right + panelGap;

      if (width < 320 || left + width > window.innerWidth - pageGap) {
        width = Math.min(Math.max(320, rect.width), window.innerWidth - pageGap * 2);
        height = Math.min(width, window.innerHeight - pageGap * 2);
        left = clamp(rect.left, pageGap, window.innerWidth - width - pageGap);
      }

      const top = clamp(rect.top, pageGap, window.innerHeight - height - pageGap);
      zoomPane.style.left = `${left}px`;
      zoomPane.style.top = `${top}px`;
      zoomPane.style.width = `${width}px`;
      zoomPane.style.height = `${height}px`;
    };

    const updateZoom = (event) => {
      const image = currentImage();
      const src = zoomSource();
      if (!mediaQuery.matches || !image || !src) {
        hideZoom();
        return;
      }

      const rect = mainImageContainer.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = clamp((event.clientX - rect.left) / rect.width, 0, 1);
      const y = clamp((event.clientY - rect.top) / rect.height, 0, 1);

      placeZoomPane(rect);
      zoomPane.style.backgroundImage = `url("${src.replace(/"/g, '%22')}")`;
      zoomPane.style.backgroundSize = '230% 230%';
      zoomPane.style.backgroundPosition = `${x * 100}% ${y * 100}%`;
      zoomPane.classList.add('is-visible');

      lens.style.left = `${x * 100}%`;
      lens.style.top = `${y * 100}%`;
      lens.classList.add('is-visible');
    };

    mainImageContainer.addEventListener('mouseenter', (event) => {
      isActive = true;
      updateZoom(event);
    });
    mainImageContainer.addEventListener('mousemove', (event) => {
      if (isActive) updateZoom(event);
    });
    mainImageContainer.addEventListener('mouseleave', hideZoom);
    mainImageContainer.addEventListener('touchstart', hideZoom, { passive: true });
    window.addEventListener('scroll', hideZoom, { passive: true });
    window.addEventListener('resize', hideZoom);
    mediaQuery.addEventListener?.('change', hideZoom);
  };

  setupHoverZoom();

  root.querySelectorAll('[data-pxp-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const imageUrl = thumb.dataset.imageUrl;
      if (!imageUrl || !mainImageContainer) return;

      root.querySelectorAll('[data-pxp-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');

      const image = mainImageContainer.querySelector('img');
      if (image) {
        image.src = imageUrl;
        image.srcset = '';
        image.alt = thumb.dataset.imageAlt || image.alt || '';
      }
      if (zoomLink) zoomLink.href = thumb.dataset.zoomUrl || imageUrl;
    });
  });

  const quantityInputs = all('[data-pxp-quantity]');
  const syncQuantity = (value) => {
    const nextValue = Math.max(1, Number.parseInt(value, 10) || 1);
    quantityInputs.forEach((input) => {
      input.value = String(nextValue);
    });
  };

  all('[data-pxp-qty-minus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.tl-pfinal-stepper')?.querySelector('[data-pxp-quantity]');
      syncQuantity((Number.parseInt(input?.value, 10) || 1) - 1);
    });
  });

  all('[data-pxp-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.tl-pfinal-stepper')?.querySelector('[data-pxp-quantity]');
      syncQuantity((Number.parseInt(input?.value, 10) || 1) + 1);
    });
  });

  quantityInputs.forEach((input) => {
    input.addEventListener('change', () => syncQuantity(input.value));
  });

  const variantDataNode = root.querySelector('[data-pxp-variants-json]');
  let variantData = { variants: [] };
  if (variantDataNode?.textContent.trim()) {
    try {
      variantData = JSON.parse(variantDataNode.textContent);
    } catch (error) {
      variantData = { variants: [] };
    }
  }

  const variants = Array.isArray(variantData.variants) ? variantData.variants : [];
  const optionGroups = Array.from(root.querySelectorAll('[data-pxp-option-group]'));
  const stickyVariantInput = stickyBuy?.querySelector('[data-pxp-sticky-variant-input]');
  const priceTargets = [
    ...Array.from(root.querySelectorAll('[data-pxp-price]')),
    ...(stickyBuy ? Array.from(stickyBuy.querySelectorAll('[data-pxp-sticky-price]')) : [])
  ];
  const stockTargets = [
    ...Array.from(root.querySelectorAll('[data-pxp-stock]')),
    ...(stickyBuy ? Array.from(stickyBuy.querySelectorAll('[data-pxp-sticky-stock]')) : [])
  ];

  const currentVariant = variants.find((variant) => String(variant.id) === String(variantData.current_variant_id)) || variants[0];

  const setMainImageFromVariant = (variant) => {
    const imageData = variant?.featured_image;
    if (!imageData?.url || !mainImageContainer) return;

    const image = mainImageContainer.querySelector('img');
    if (image) {
      image.src = imageData.url;
      image.srcset = '';
      image.alt = imageData.alt || image.alt || '';
    }
    if (zoomLink) zoomLink.href = imageData.zoom_url || imageData.url;

    root.querySelectorAll('[data-pxp-thumb]').forEach((thumb) => {
      const isMatchingThumb = thumb.dataset.imageUrl === imageData.url || thumb.dataset.zoomUrl === imageData.zoom_url;
      thumb.classList.toggle('is-active', isMatchingThumb);
    });
  };

  const updateVariant = (variant) => {
    if (!variant) return;

    root.querySelectorAll('[data-pxp-main-variant-input]').forEach((input) => {
      input.value = String(variant.id);
    });
    if (stickyVariantInput) stickyVariantInput.value = String(variant.id);

    if (variant.price) {
      priceTargets.forEach((target) => {
        target.textContent = variant.price;
      });
    }

    const isAvailable = Boolean(variant.available);
    stockTargets.forEach((target) => {
      target.textContent = isAvailable ? target.dataset.inStockText || 'In Stock' : target.dataset.soldOutText || 'Sold Out';
      target.classList.toggle('is-sold-out', !isAvailable);
    });

    all('[data-pxp-add]').forEach((button) => {
      button.disabled = !isAvailable;
      button.textContent = isAvailable ? button.dataset.availableText : button.dataset.soldOutText;
    });

    setMainImageFromVariant(variant);
  };

  const selectedOptions = () => {
    const nextOptions = [];
    optionGroups.forEach((group) => {
      const optionIndex = Number.parseInt(group.dataset.optionIndex, 10);
      const activeButton = group.querySelector('[data-pxp-option-value].is-active');
      nextOptions[optionIndex] = activeButton?.dataset.optionValue;
    });
    return nextOptions;
  };

  const findVariantByOptions = (optionValues) => variants.find((variant) => (
    Array.isArray(variant.options)
    && variant.options.length === optionValues.length
    && variant.options.every((value, index) => value === optionValues[index])
  ));

  root.querySelectorAll('[data-pxp-option-value]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-pxp-option-group]');
      if (!group) return;

      group.querySelectorAll('[data-pxp-option-value]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });

      const matchedVariant = findVariantByOptions(selectedOptions());
      updateVariant(matchedVariant);
    });
  });

  if (variants.length && optionGroups.length) {
    updateVariant(findVariantByOptions(selectedOptions()) || currentVariant);
  }

  const renderKeyFeatures = () => {
    const dataNode = root.querySelector('[data-pxp-key-features-json]');
    let features = [];

    if (dataNode?.textContent.trim()) {
      try {
        const parsed = JSON.parse(dataNode.textContent);
        if (Array.isArray(parsed)) {
          features = parsed.filter((item) => typeof item === 'string' && item.trim()).slice(0, 2);
        }
      } catch (error) {
        features = [];
      }
    }

    if (!features.length) {
      const firstList = root.querySelector('#product-description ul');
      const listItems = firstList ? firstList.querySelectorAll('li') : root.querySelectorAll('#product-description li');
      features = Array.from(listItems).map((item) => item.textContent.trim()).filter(Boolean).slice(0, 2);
    }

    let featureBlock = root.querySelector('.tl-pfinal-key-features');
    if (!features.length) {
      featureBlock?.remove();
      return;
    }

    const summary = root.querySelector('.tl-pfinal-summary');
    if (!featureBlock && summary) {
      featureBlock = document.createElement('div');
      featureBlock.className = 'tl-pfinal-key-features';
    }

    if (summary && featureBlock && !summary.contains(featureBlock)) {
      const title = summary.querySelector('h1');
      const buyZone = summary.querySelector('[data-pxp-buy-zone]');
      if (title) {
        title.insertAdjacentElement('afterend', featureBlock);
      } else if (buyZone) {
        buyZone.insertAdjacentElement('beforebegin', featureBlock);
      } else {
        summary.appendChild(featureBlock);
      }
    }

    const escapeHtml = (value) => value.replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);

    featureBlock.innerHTML = [
      '<div class="tl-pfinal-key-head"><span>Product Key Features</span></div>',
      `<ul>${features.map((item) => `<li>${escapeHtml(item)}</li>`).join('')}</ul>`,
      '<a class="tl-pfinal-key-view-all" href="#product-description">View all &rarr;</a>'
    ].join('');
  };

  renderKeyFeatures();

  const syncReviewsVisibility = () => {
    const reviewLine = root.querySelector('[data-pxp-review-line]');
    const reviewsSection = root.querySelector('[data-pxp-reviews-section]');
    if (!reviewLine && !reviewsSection) return;

    const hasReviewAppBlock = reviewsSection?.dataset.hasReviewAppBlock === 'true';
    const candidates = [
      reviewLine,
      reviewsSection,
      root.querySelector('[data-tl-review-native]'),
      root.querySelector('.loox-rating'),
      root.querySelector('#looxReviews'),
      root.querySelector('.jdgm-preview-badge'),
      root.querySelector('.jdgm-review-widget'),
      root.querySelector('.shopify-product-reviews-badge'),
      root.querySelector('#shopify-product-reviews'),
      root.querySelector('ryviu-widget-total'),
      root.querySelector('ryviu-widget'),
      root.querySelector('[data-tl-review-app-block]')
    ].filter(Boolean);

    const hasPositiveNumber = (text) => {
      const normalized = text.replace(/\s+/g, ' ').trim().toLowerCase();
      if (!normalized || /no reviews|0 reviews|0 review/.test(normalized)) return false;
      const reviewMatch = normalized.match(/([1-9]\d*)\s+reviews?/);
      return Boolean(reviewMatch);
    };

    const hasExplicitEmptyState = (text) => {
      const normalized = text.replace(/\s+/g, ' ').trim().toLowerCase();
      return /no reviews|0 reviews|0 review|no ratings|0 ratings|be the first to review/.test(normalized);
    };

    const hasRealReviews = candidates.some((node) => {
      const raters = Number.parseInt(node.dataset?.raters || node.dataset?.numberOfReviews || '', 10);
      const text = node.textContent || '';
      if (raters > 0) return true;
      if (hasPositiveNumber(text)) return true;
      if (text.replace(/\s+/g, ' ').trim().length > 80 && !hasExplicitEmptyState(text)) return true;
      return Boolean(node.querySelector?.('.spr-review, .jdgm-rev, .loox-review, .ryviu-review, [data-review-id], [data-judgeme-review-id]'));
    });

    const appBlockLooksEmpty = hasReviewAppBlock && reviewsSection && hasExplicitEmptyState(reviewsSection.textContent || '');
    const shouldShowReviewsSection = hasReviewAppBlock ? !appBlockLooksEmpty : hasRealReviews;

    if (reviewLine) reviewLine.hidden = !hasRealReviews;
    if (reviewsSection) reviewsSection.hidden = !shouldShowReviewsSection;
  };

  syncReviewsVisibility();
  [600, 1600, 3200, 5200].forEach((delay) => window.setTimeout(syncReviewsVisibility, delay));

  const setupRecentlyViewed = () => {
    const storageKey = 'treedix_recently_viewed_products';
    const section = root.querySelector('[data-pxp-recently-viewed]');
    const grid = root.querySelector('[data-pxp-recently-viewed-grid]');
    const currentProductNode = root.querySelector('[data-pxp-current-product]');
    if (!section || !grid || !currentProductNode) return;
    const viewProductLabel = section.dataset.viewProductLabel || 'View Product';

    let currentProduct = null;
    let history = [];

    try {
      currentProduct = JSON.parse(currentProductNode.textContent);
    } catch (error) {
      currentProduct = null;
    }

    try {
      const stored = window.localStorage.getItem(storageKey);
      const parsed = stored ? JSON.parse(stored) : [];
      history = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      history = [];
    }

    const normalizeProduct = (item) => ({
      id: item?.id ? String(item.id) : '',
      title: item?.title ? String(item.title) : '',
      url: item?.url ? String(item.url) : '',
      price: item?.price ? String(item.price) : '',
      image: item?.image ? String(item.image) : ''
    });

    const current = normalizeProduct(currentProduct);
    const recentItems = history
      .map(normalizeProduct)
      .filter((item) => item.id && item.title && item.url && item.price && item.image)
      .filter((item) => item.id !== current.id)
      .slice(0, 4);

    const escapeHtml = (value) => value.replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);

    if (recentItems.length) {
      grid.innerHTML = recentItems.map((item) => `
        <article class="tl-pfinal-recent-card continue-exploring-card">
          <a class="tl-pfinal-recent-image continue-exploring-image" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}">
            <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async" width="500" height="500">
          </a>
          <div class="tl-pfinal-recent-copy">
            <a class="tl-pfinal-recent-title continue-exploring-title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
            <strong>${escapeHtml(item.price)}</strong>
            <a class="tl-pfinal-recent-link" href="${escapeHtml(item.url)}">${escapeHtml(viewProductLabel)}</a>
          </div>
        </article>
      `).join('');
      section.hidden = false;
    } else {
      section.hidden = true;
    }

    if (current.id && current.title && current.url && current.price && current.image) {
      const nextHistory = [
        current,
        ...history.map(normalizeProduct).filter((item) => item.id !== current.id && item.url !== current.url)
      ].filter((item) => item.id && item.title && item.url && item.price && item.image).slice(0, 12);

      try {
        window.localStorage.setItem(storageKey, JSON.stringify(nextHistory));
      } catch (error) {
        // Ignore storage failures in private browsing or restricted contexts.
      }
    }
  };

  setupRecentlyViewed();

  const buyBox = root.querySelector('[data-pxp-primary-actions], [data-buy-box], [data-pxp-buy-zone]');
  const setStickyVisible = (isVisible) => {
    if (!stickyBuy) return;
    stickyBuy.hidden = !isVisible;
    stickyBuy.classList.toggle('is-visible', isVisible);
    document.body.classList.toggle('tl-sticky-buy-visible', isVisible);
  };

  const isBuyBoxVisible = () => {
    if (!buyBox) return true;
    const rect = buyBox.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  if (stickyBuy && buyBox && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setStickyVisible(!(entry.isIntersecting && entry.intersectionRatio > 0));
    }, { threshold: 0.08 });
    observer.observe(buyBox);
    setStickyVisible(!isBuyBoxVisible());
    window.addEventListener('resize', () => setStickyVisible(!isBuyBoxVisible()));
  } else if (stickyBuy && buyBox) {
    const checkSticky = () => setStickyVisible(!isBuyBoxVisible());
    window.addEventListener('scroll', checkSticky, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }

  const videoModal = root.querySelector('[data-tl-video-modal]');
  const videoFrame = root.querySelector('[data-tl-video-frame]');

  const videoUrl = (rawUrl) => {
    try {
      const url = new URL(rawUrl, window.location.origin);
      const host = url.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : rawUrl;
      }
      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const parts = url.pathname.split('/').filter(Boolean);
        const id = url.searchParams.get('v') || parts[parts.indexOf('embed') + 1] || parts[parts.indexOf('shorts') + 1];
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : rawUrl;
      }
      if (host === 'vimeo.com') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : rawUrl;
      }
      if (host === 'player.vimeo.com') {
        url.searchParams.set('autoplay', '1');
        return url.toString();
      }
    } catch (error) {
      return rawUrl;
    }
    return rawUrl;
  };

  const closeVideo = () => {
    if (!videoModal || !videoFrame) return;
    videoFrame.innerHTML = '';
    videoModal.hidden = true;
    document.body.classList.remove('tl-video-open');
  };

  const openVideo = (rawUrl) => {
    if (!videoModal || !videoFrame || !rawUrl) return;
    const url = videoUrl(rawUrl);
    videoFrame.innerHTML = '';
    if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(url)) {
      const video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      videoFrame.appendChild(video);
    } else {
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = 'Product video';
      videoFrame.appendChild(iframe);
    }
    videoModal.hidden = false;
    document.body.classList.add('tl-video-open');
  };

  root.querySelectorAll('[data-tl-video-open]').forEach((opener) => {
    opener.addEventListener('click', () => openVideo(opener.dataset.videoUrl));
  });

  root.querySelectorAll('[data-tl-video-close]').forEach((closer) => {
    closer.addEventListener('click', closeVideo);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeVideo();
  });
})();
